import hashHelper from '@core/helpers/hashHelper';
import { LoginStore } from '@modules/authentication/pages/login/login.store';
import { useStore } from '@policoders/di';
import { Link } from 'react-router-dom';

const UserMenu = () => {
  const { state, logout } = useStore<LoginStore>('LoginStore');
  const { user } = state;
  const email = user?.email;
  const image: any = null;
  const emailHash = email ? hashHelper.MD5(email) : null;

  return (
    <div className="dropdown ps-lg-3">
      <a
        href="/#"
        className="d-block link-light text-decoration-none dropdown-toggle"
        id="dropUser"
        data-bs-toggle="dropdown"
        aria-expanded="false">
        <img
          src={image ? image : emailHash ? `https://www.gravatar.com/avatar/${emailHash}` : null}
          alt={email}
          width="40"
          height="40"
          className="rounded-circle border border-2 d-none d-lg-inline"
        />
        <span className="d-inline d-lg-none">{user?.email}</span>
      </a>
      <ul
        className="dropdown-menu dropdown-menu-dark dropdown-menu-lg-end text-small"
        aria-labelledby="dropUser">
        <li>
          <Link className="dropdown-item" to="/profile">
            Perfil de usuário
          </Link>
        </li>
        <li>
          <Link className="dropdown-item" to="/administration">
            Administração
          </Link>
        </li>
        <li>
          <hr className="dropdown-divider" />
        </li>
        <li>
          <Link className="dropdown-item" to="/login" onClick={logout}>
            Sair
          </Link>
        </li>
      </ul>
    </div>
  );
};

export { UserMenu };
